import { render, staticRenderFns } from "./UploadableItem.vue?vue&type=template&id=2f6b4158&scoped=true"
import script from "./UploadableItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadableItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UploadableItem.vue?vue&type=style&index=0&id=2f6b4158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b4158",
  null
  
)

export default component.exports